module.exports = __webpack_public_path__ + "static/1284690585.66c52f77.jpg";